export default "__VITE_ASSET__0ef45af2__"